import './App.css';
import React, { useCallback, useEffect, useState } from 'react';
import Modal from './Modal.js';
import Instructions from './Instructions';
import Game from './Game.jsx';
import { GenerateResources } from './utils.js';
import { Button } from '@blueprintjs/core';

function Unlimited() {
  const [m, setM] = useState(7);
  const [n, setN] = useState(7);
  const [fillPercent, setFillPercent] = useState(50);
  const [game, setGame] = useState({
    m: m,
    n: n,
    units: ["Sheep", "Giraffe", "Elephant", "Monkey", "Peacock", "Duck"],
    objects: GenerateResources([m, n], fillPercent)
  })
  const [miningRate, setMiningRate] = useState(0);
  const [score, setScore] = useState(0);
  const [showInstructions, setShowInstructions] = useState(false);
  const [gameKey, setGameKey] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setScore(score => score + miningRate);
    }, 1000);

    return () => clearInterval(interval);
  }, [miningRate])

  const GenerateNewGame = useCallback(() => {
    console.log('Generating new map');
    setGameKey(gameKey => gameKey + 1);
    setMiningRate(0);
    setGame({
      m: m,
      n: n,
      units: ["Sheep", "Giraffe", "Elephant", "Monkey", "Peacock", "Duck"],
      objects: GenerateResources([m, n], fillPercent),
    });
  }, [m, n, fillPercent])

  return (
    <div className="App">
      <Button icon='info-sign' text='Instructions' onClick={() => setShowInstructions(true)} />

      <Game key={gameKey} game={game} SetMiningRate={setMiningRate} />

      <div style={{ display: 'flex', flexDirection: 'column', border: 'solid', borderWidth: '1px', borderRadius: '5px', padding: '20px 50px' }}>
        <input type='range' min={20} max={80} step={5} value={fillPercent} onChange={(e) => setFillPercent(e.target.value)} />
        <label>Resource Density (%): {fillPercent}</label>
        <input type='range' min={3} max={7} value={m} onChange={(e) => setM(e.target.value)} />
        <label>rows: {m}</label>
        <input type='range' min={3} max={7} value={n} onChange={(e) => setN(e.target.value)} />
        <label>columns: {n}</label>
        <br />
        <Button icon="refresh" text="New Game" onClick={GenerateNewGame} />
      </div>

      <p style={{marginTop: '10px'}}>Total mined: {score.toFixed(2)}</p>

      {showInstructions && <Modal closeModal={() => { setShowInstructions(false) }}>
        <Instructions />
      </Modal>}
    </div>
  );
}

export default Unlimited;
